module.exports = __webpack_public_path__ + "static/Irvan Bastian Arief-f25b2b00276171cbf808a8690fc14d55.jpg";